var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" rounded p-1 px-2  btn-block text-nowrap text-white",class:{
    'bg-success': _vm.planStatus == 2 || _vm.planStatus == 3,
    'bg-danger': _vm.planStatus == 1,
    'bg-warning': _vm.planStatus == 4,
    'bg-info': _vm.planStatus == 0
  }},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }